import { OffersGroupsDetails } from 'pages/loyalty/loyalty-offers/loyalty-offers-groups-details';

export default function OfferGroupDetails() {
  return <OffersGroupsDetails />;
}
